import { render } from "./DomesticAdmin.vue?vue&type=template&id=78ae4992"
import script from "./DomesticAdmin.vue?vue&type=script&lang=js"
export * from "./DomesticAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__